import qs from "qs";
import httpGet from "./httpget";
import httpPost from "./httppost";
import httpPut from "./httpput";
import httpDelete from "./httpdelete";
import { REQUEST_URL, IAM_URL } from "src/const/const";
import config from "./config";
const isIe = !!window.ActiveXObject || "ActiveXObject" in window;
const domain = process.env.NODE_ENV === "development" ? "/api" : REQUEST_URL;

/**
 * @description: 确认iam_token状态
 * @param {*}
 * @return {*}
 */
export const checkAccountLogin = (params = {}, config = {}) =>
  httpPost({
    url: `${IAM_URL}/api/mine/checkAccountLogin?v=${isIe ? Math.random() : ""}`,
    params,
    config: {
      noErrorHandler: true,
      noAuth: true, // 无需判断token参数
      noAppKey: true,
      ...config,
    },
  });

/**
 * @description: 确认iam_token状态
 * @param {*}
 * @return {*}
 */
export const checkCloudAccountLogin = (params = {}, config = {}) =>
  httpGet({
    url: `https://webapi.foxitcloud.cn/accountopenapi/authorization/validateCookieAccessToken?domain=.foxitcloud.cn&v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config: {
      noErrorHandler: true,
      noAuth: true, // 无需判断token参数
      noAppKey: true,
      ...config,
    },
  });

/**
 * @description: 确认iam_token状态
 * @param {*}
 * @return {*}
 */
export const getShortToken = (config = {}) =>
  httpGet({
    url: `https://vip.foxitreader.cn/createShortIamToken?v=${
      isIe ? Math.random() : ""
    }`,
    config: {
      noAppKey: true,
      noAuth: true,
      ...config
    },
  });

/**
 * @description: 获取IAM账号状态
 * @param {*}
 * @return {*}
 */
export const getCurrentUser = (params = {}, config = {}) =>
  httpGet({
    url: `${IAM_URL}/api/mine/current_user?v=${isIe ? Math.random() : ""}`,
    params,
    config: {
      ...config,
    },
  });

/**
 * @description: 获取账号列表
 * @param {*}
 * @return {*}
 */
export const getMineAccounts = (params = {}, config = {}) =>
  httpGet({
    url: `${IAM_URL}/api/mine/session/accounts?v=${isIe ? Math.random() : ""}`,
    params,
    config: {
      ...config,
    },
  });

/**
 * @description: 获取令牌
 * @param {*}
 * @return {*}
 */
export const getToken = (params = {}, config = {}) =>
  httpGet({
    url: `${domain}/user/getToken?v=${isIe ? Math.random() : ""}`,
    params,
    config: {
      noAuth: true, // 无需判断token参数
      ...config,
    },
  });

export const getTokenNoFid = (params = {}, config = {}) =>
  httpGet({
    url: `${domain}/user/getExchangeToken?v=${isIe ? Math.random() : ""}`,
    params,
    config: {
      noAuth: true, // 无需判断token参数
      noToken: true,
      ...config,
    },
  });

/**
 * @description: 获取用户信息
 * @param {*}
 * @return {*}
 */
export const getUserInfo = (params = {}, config = {}) =>
  httpGet({
    url: `${domain}/user/getUserInfo?v=${isIe ? Math.random() : ""}`,
    params,
    config,
  });

//获取设备列表
export function getEquipmentList(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printEquipment/findPrintEquipmentList?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config: {
      showLoading: true,
      ...config,
    },
  });
}

//查询当前设备参数
export function getEquipmentId(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printEquipment/findPrintEquipment/${params.equipmentId}?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config,
  });
}

//设置默认打印机
export function setDefault(params = {}, config = {}) {
  let id = params.id;
  return httpPut({
    url: `${domain}/printEquipment/defaultPrintEquipment/${id}?v=${
      isIe ? Math.random() : ""
    }`,
    params: qs.stringify(params),
    config,
  });
}

//删除设备
export function removeDevice(params = {}, config = {}) {
  let id = params.id;
  return httpDelete({
    url: `${domain}/printEquipment/deletePrintEquipment/${id}?v=${
      isIe ? Math.random() : ""
    }`,
    params: qs.stringify(params),
    config,
  });
}

export function findPrintVipUser() {
  return httpGet({
    url: `${domain}/printVipUser/findPrintVipUser?v=${
      isIe ? Math.random() : ""
    }`,
    config,
  });
}

//取消上传记录
export function cancelPrintDocConvert(params = {}, config = {}) {
  return httpDelete({
    url: `${domain}/printDocConvert/cancelPrintDocConvert/${params.printNo}?v=${
      isIe ? Math.random() : ""
    }`,
    params: qs.stringify(params),
    config,
  });
}

//解绑设备
export function unBindEquipment(params = {}, config = {}) {
  return httpDelete({
    url: `${domain}/printEquipmentShareBind/unBindEquipment/${
      params.equipmentId
    }?v=${isIe ? Math.random() : ""}`,
    params: qs.stringify(params),
    config,
  });
}

//移除成员
export function deleteBindEquipment(params = {}, config = {}) {
  return httpDelete({
    url: `${domain}/printEquipmentShareBind/deleteBindEquipment`,
    params: params,
    config: {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      ...config,
    },
  });
}

//取消分享
export function cancelShare(params = {}, config = {}) {
  return httpDelete({
    url: `${domain}/printEquipmentShare/cancelShare/${params.equipmentId}?v=${
      isIe ? Math.random() : ""
    }`,
    params: qs.stringify(params),
    config,
  });
}

//修改打印机名称
export function modifyPrinterName(params = {}, config = {}) {
  return httpPut({
    url: `${domain}/printEquipment/updatePrintEquipment?v=${
      isIe ? Math.random() : ""
    }`,
    params: qs.stringify(params),
    config,
  });
}

//修改所有打印参数
export function modifyingPrintParameters(params = {}, config = {}) {
  let id = params.id;
  return httpPut({
    url: `${domain}/printEquipment/updatePrintEquipmentAndOptions/${id}?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config: {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      ...config,
    },
  });
}

//修改快印码状态
export function setQrCode(params = {}, config = {}) {
  let id = params.id;
  return httpPut({
    url: `${domain}/printEquipment/settingQrCode/${id}?v=${
      isIe ? Math.random() : ""
    }`,
    params: qs.stringify(params),
    config,
  });
}

//生成快印码
export function generateCode(params = {}, config = {}) {
  let id = params.id;
  return httpGet({
    url: `${domain}/printEquipment/getQrCode/${id}?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config,
  });
}

//创建新码
export function newCode(params = {}, config = {}) {
  return httpPut({
    url: `${domain}/printEquipment/refreshQrCode/${params.id}`,
    params: qs.stringify(params),
    config,
  });
}

//设备海报转换
export function getQuickPrintCodePoster(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printDocConvert/equipmentQrCodePoster`,
    params,
    config,
  });
}

//查询是否有打印记录
export function hasEquipmentPrinting(params = {}, config = {}) {
  let id = params.id;
  return httpGet({
    url: `${domain}/printEquipment/hasEquipmentPrinting/${id}?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config,
  });
}

//导出明细
export function exportDetailed(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printStatistics/downloadStatisticsDetailMonth?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config,
  });
}

//顶部概要数据
export function outline(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printStatistics/statisticsMonth?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config,
  });
}

// 趋势统计
export function statisticsDetailMonth(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printStatistics/statisticsDetailMonth?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config,
  });
}

// 上传转换文档
export function uploadConverter(params = {}, config = {}) {
  const formData = new FormData();
  for (let key in params) {
    formData.append(key, params[key]);
  }
  return httpPost({
    url: `${domain}/printDocConvert/uploadConvert`,
    params: formData,
    config,
  });
}

//查询文档状态
export function fileQuery(printNo = "", config = {}) {
  return httpGet({
    url: `${domain}/printDocConvert/getPrintDocConvert/${printNo}?v=${
      isIe ? Math.random() : ""
    }`,
    config: {
      showLoading: true,
      ...config,
    },
  });
}

//获取所有打印参数
export function getAllParameters(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printSetting/findPrintSettingList?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config,
  });
}

//打印参数
export function printSettings(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printDocPrinting/setting?v=${isIe ? Math.random() : ""}`,
    params,
    config,
  });
}

//开始打印
export function startPrinting(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printDocPrinting/print/${params.printNo}?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config,
  });
}

//获取打印列表
export function getPrintingList(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printDocPrinting/findPrintDocPrintingList?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config,
  });
}

//获取分享设备列表
export function findSharePrintEquipmentList(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printEquipment/findSharePrintEquipmentList?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config: {
      showLoading: true,
      ...config,
    },
  });
}

//获取分享设备列表
export function bindEquipmentList(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printEquipmentShareBind/bindEquipmentList/${
      params.equipmentId
    }?v=${isIe ? Math.random() : ""}`,
    params,
    config,
  });
}

//取消打印
export function cancelPrinting(params = {}, config = {}) {
  let printNo = params.printNo;
  return httpPut({
    url: `${domain}/printDocPrinting/cancelPrint/${printNo}`,
    params,
    config,
  });
}

//置顶排序
export function topSort(params = {}, config = {}) {
  let printNo = params.printNo;
  return httpPut({
    url: `${domain}/printDocPrinting/topSort/${printNo}`,
    params,
    config,
  });
}

//选择云文档文件进行转换
export function docsConvert(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printDocConvert/docsConvert`,
    params,
    config,
  });
}

//获取下载地址
export function getDownUrl(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printDocConvert/getDownloadURL/${params.printNo}?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config,
  });
}

//获取分享信息
export function getShare(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printEquipmentShare/getShare`,
    params,
    config,
  });
}

//绑定打印机
export function bindEquipment(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printEquipmentShareBind/bindEquipment`,
    params,
    config: {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      ...config,
    },
  });
}

//批量打印设置
export function batchSetting(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printDocPrinting/batchSetting`,
    params,
    config: {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      ...config,
    },
  });
}

//批量打印设置
export function batchPrint(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printDocPrinting/batchPrint`,
    params,
    config: {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      ...config,
    },
  });
}

//创建分享
export function createShare(params = { equipmentId }, config = {}) {
  return httpPost({
    url: `${domain}/printEquipmentShare/createShare/${params.equipmentId}`,
    params,
    ...config,
  });
}

// 查询订单
export function orderInfo(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printPayOrder/orderInfo/${params.orderId}`,
    params,
    config,
  });
}

// 查询订单详情
export function orderInfoDetail(params = {}, config = {}) {
  return httpGet({
    url: `${domain}/printPayOrder/findPayerOrderDetailList/${params.orderId}`,
    params,
    config,
  });
}

//计算价格
export function calculatePrice(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printPayOrder/calculatePrice/${params.id}`,
    params: params.printNoList,
    config: {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      ...config,
    },
  });
}

//批量打印设置
export function createOrder(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printPayOrder/createOrder/${params.id}`,
    params: params.printNoList,
    config: {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      ...config,
    },
  });
}

//批量查询转换状态
export function batchGetPrintDocConvert(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printDocConvert/batchGetPrintDocConvert`,
    params,
    config: {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      ...config,
    },
  });
}

// 检测白名单
export function checkWhiteList(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printDocPrinting/checkWhiteList/${params.equipmentId}`,
    params,
    config,
  });
}

/**
 * @description: 设置消息提醒
 * @param {*}
 * @return {*}
 */
export function settingAlarmStatus(params = {}, config = {}) {
  return httpPut({
    url: `${domain}/printEquipment/settingAlarmStatus/${params.id}`,
    params: qs.stringify(params),
    config,
  });
}

//批量取消打印
export function batchCancelPrinting(params = {}, config = {}) {
  return httpPost({
    url: `${domain}/printDocPrinting/batchCancelPrint?v=${
      isIe ? Math.random() : ""
    }`,
    params,
    config: {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      ...config,
    },
  });
}

//重新打印
export function reprint(params = {}, config = {}) {
  let printNo = params.printNo;
  return httpPut({
    url: `${domain}/printDocPrinting/reprint/${printNo}?v=${
      isIe ? Math.random() : ""
    }`,
    config,
  });
}

/**
 * @description: 获取小程序 scheme 码
 * @param {*}
 * @return {*}
 */
export const getUrlScheme = (params = {}, config = {}) =>
  httpPost({
    url: `${domain}/common/getUrlScheme?v=${isIe ? Math.random() : ""}`,
    params,
    config,
  });

/**
 * @description: 新版支付
 * @param {*}
 * @return {*}
 */
export const crateVipOrder = (params = {}, config = {}, extra) =>
  httpPost({
    url: `https://pay-api.foxitreader.cn/pay-api/pay/unifiedOrder?extra=${extra}&v=${isIe ? Math.random() : ""}`,
    params,
    config,
  });
